(() => {
const root = document.querySelector('[data-sfj-p]');
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
let product;
try { product = JSON.parse(root.querySelector('[data-sfj-product]').textContent); } catch (e) { return; }
const money = (cents) => {
const fmt = root.dataset.money || '${{amount}}';
const v = (cents / 100).toFixed(2);
return fmt.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
};
const track = root.querySelector('[data-sfj-track]');
const slides = [...root.querySelectorAll('[data-sfj-slide]')];
const thumbs = [...root.querySelectorAll('[data-sfj-thumb]')];
const dots = [...root.querySelectorAll('.sfj-p__dots i')];
const bar = root.querySelector('[data-sfj-progress]');
const goTo = (i) => { const s = slides[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); };
thumbs.forEach(t => t.addEventListener('click', () => goTo(Number(t.dataset.sfjThumb))));
const onScroll = () => {
const x = track.scrollLeft;
let idx = 0;
slides.forEach((s, i) => { if (s.offsetLeft - 5 <= x) idx = i; });
if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) idx = slides.length - 1;
thumbs.forEach((t, i) => t.classList.toggle('is-on', i === idx));
dots.forEach((d, i) => d.classList.toggle('is-on', i === idx));
if (bar) { const max = track.scrollWidth - track.clientWidth; bar.style.width = (max > 0 ? Math.max(20, (x / max) * 100) : 100) + '%'; }
};
track.addEventListener('scroll', onScroll, { passive: true });
let down = false, sx = 0, sl = 0, moved = false;
track.addEventListener('mousedown', (e) => { down = true; moved = false; sx = e.pageX; sl = track.scrollLeft; });
window.addEventListener('mousemove', (e) => { if (!down) return; const dx = e.pageX - sx; if (Math.abs(dx) > 4) { moved = true; track.classList.add('is-drag'); } track.scrollLeft = sl - dx; });
track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
window.addEventListener('mouseup', () => { if (!down) return; down = false; track.classList.remove('is-drag'); if (moved) { let best = 0, bd = 1e9; slides.forEach((s, i) => { const d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < bd) { bd = d; best = i; } }); goTo(best); } });
const opts = [...root.querySelectorAll('[data-sfj-opt]')];
const idInput = root.querySelector('[data-sfj-id]');
const atc = root.querySelector('[data-sfj-atc]');
const atcText = root.querySelector('[data-sfj-atc-text]');
const priceNow = root.querySelector('[data-sfj-price-now]');
const priceWas = root.querySelector('[data-sfj-price-was]');
const stickyPrice = root.querySelector('[data-sfj-sticky-price]');
const stickyBtn = root.querySelector('[data-sfj-sticky-btn]');
const stock = root.querySelector('[data-sfj-stock]');
const addLabel = atcText ? atcText.textContent.trim() : 'Add to cart';
const selected = () => opts.map(o => { const b = o.querySelector('.sfj-p__val.is-on'); return b ? b.dataset.sfjVal : null; });
const findVariant = (vals) => product.variants.find(v => v.options.every((o, i) => vals[i] == null || o === vals[i]));
const update = (scrollToMedia) => {
const v = findVariant(selected());
opts.forEach((o, i) => {
const lab = o.querySelector('[data-sfj-opt-val]'); const on = o.querySelector('.sfj-p__val.is-on');
if (lab && on) lab.textContent = on.dataset.sfjVal.split('|')[0].trim();
o.querySelectorAll('.sfj-p__val').forEach(b => {
const vals = selected(); vals[i] = b.dataset.sfjVal;
const m = findVariant(vals); b.classList.toggle('is-na', !m || !m.available);
});
});
if (!v) { atc.disabled = true; atcText.textContent = 'Unavailable'; return; }
idInput.value = v.id;
priceNow.textContent = money(v.price);
if (stickyPrice) stickyPrice.textContent = money(v.price);
if (v.compare_at_price && v.compare_at_price > v.price) { priceWas.textContent = money(v.compare_at_price); priceWas.hidden = false; } else priceWas.hidden = true;
atc.disabled = !v.available; atcText.textContent = v.available ? addLabel : 'Sold out';
if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? addLabel : 'Sold out'; }
if (stock && !v.available) { stock.className = 'sfj-p__stock sfj-p__stock--out'; stock.querySelector('span').textContent = 'Sold out'; }
if (scrollToMedia) { const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url); if (v.featured_media) { const i = slides.findIndex(s => s.dataset.mediaId == v.featured_media.id); if (i > -1) goTo(i); } }
};
opts.forEach(o => o.addEventListener('click', (e) => {
const b = e.target.closest('.sfj-p__val'); if (!b) return;
o.querySelectorAll('.sfj-p__val').forEach(x => x.classList.toggle('is-on', x === b));
update(true);
}));
root.addEventListener('change', (e) => {
if (e.target.id === 'addChainToggle') { const box = root.querySelector('#chainOptions'); if (box) box.hidden = !e.target.checked; }
if (e.target.name === 'chain_style') {
const idx = e.target.dataset.chainIndex;
root.querySelectorAll('.chain-length-box').forEach(b => { b.hidden = b.dataset.chainIndex !== idx; });
root.querySelectorAll('input[name="chain_variant"][type="radio"]').forEach(i => { i.checked = false; });
}
});
const chainVariant = () => {
const t = root.querySelector('#addChainToggle');
if (!t || !t.checked) return null;
const style = root.querySelector('input[name="chain_style"]:checked');
if (!style) return 'missing';
const box = root.querySelector('.chain-length-box[data-chain-index="' + style.dataset.chainIndex + '"]');
if (!box) return 'missing';
const pick = box.querySelector('input[name="chain_variant"]:checked') || box.querySelector('input[name="chain_variant"][type="hidden"]');
return pick ? pick.value : 'missing';
};
const form = root.querySelector('[data-sfj-form]');
const err = root.querySelector('[data-sfj-err]');
const add = async () => {
if (atc.disabled) return;
err.hidden = true;
const items = [{ id: Number(idInput.value), quantity: 1 }];
const cv = chainVariant();
if (cv === 'missing') { err.textContent = 'Pick a chain option, or untick the add-on.'; err.hidden = false; return; }
if (cv) items.push({ id: Number(cv), quantity: 1 });
atc.classList.add('is-loading'); atc.disabled = true;
try {
const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
const d = await r.json();
if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
document.dispatchEvent(new CustomEvent('on:cart:add', { detail: { variantId: items[0].id } }));
document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
setTimeout(() => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')), 250);
} catch (e2) {
err.textContent = e2.message; err.hidden = false;
} finally {
atc.classList.remove('is-loading'); atc.disabled = false; update(false);
}
};
form.addEventListener('submit', (e) => { e.preventDefault(); add(); });
const sticky = root.querySelector('[data-sfj-sticky]');
if (sticky) {
const gallery = root.querySelector('.sfj-p__gallery');
const desk = window.matchMedia('(min-width: 990px)');
let ticking = false;
const check = () => {
ticking = false;
const past = desk.matches ? window.scrollY > gallery.offsetHeight * 0.55 : atc.getBoundingClientRect().bottom < 0;
sticky.classList.toggle('is-on', past);
document.body.classList.toggle('sfj-sticky-on', past);
sticky.setAttribute('aria-hidden', !past);
};
window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
check();
stickyBtn.addEventListener('click', () => {
if (opts.length && !findVariant(selected())) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
add();
});
}
update(false);
onScroll();
})();